import { Link } from "react-router-dom";
import { Radio, Mic2, Users, UploadCloud, Globe, RefreshCw, Inbox, ExternalLink } from "lucide-react";
import { timeAgo } from "@/lib/api";

const KIND = {
  show: [Radio, "bg-sky-400/15 text-sky-300"],
  episode: [Mic2, "bg-amber-400/15 text-amber-300"],
  host: [Users, "bg-emerald-400/15 text-emerald-300"],
  submission: [UploadCloud, "bg-fuchsia-400/15 text-fuchsia-300"],
  site: [Globe, "bg-indigo-400/15 text-indigo-300"],
  sync: [RefreshCw, "bg-slate-400/15 text-slate-300"],
  inbox: [Inbox, "bg-rose-400/15 text-rose-300"],
};

export const ActivityItem = ({ item, index, showDate }) => {
  const [Icon, cls] = KIND[item.kind] || KIND.site;
  const external = item.link && !item.link.startsWith("/admin");
  const body = (
    <>
      <span className={`h-8 w-8 shrink-0 rounded-full flex items-center justify-center ${cls}`}><Icon size={14} /></span>
      <div className="min-w-0 flex-1">
        <p className="text-sm text-slate-100 leading-snug" data-testid={`activity-message-${index}`}>{item.message}</p>
        <p className="text-[11px] text-slate-500 mt-0.5">
          <span className="text-slate-400">{item.actor}</span>{item.role && item.role !== "system" ? ` · ${item.role === "podcaster" ? "host" : item.role}` : ""} · {showDate ? new Date(item.created_at).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : timeAgo(item.created_at)}
        </p>
      </div>
      {item.link && <ExternalLink size={12} className="text-slate-600 shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity" />}
    </>
  );
  const cls2 = "group flex items-start gap-3 rounded-xl px-3 py-2.5 transition-colors hover:bg-white/5";
  if (!item.link) return <li className={cls2} data-testid={`activity-item-${index}`}>{body}</li>;
  return (
    <li data-testid={`activity-item-${index}`}>
      {external ? <a href={item.link} target="_blank" rel="noreferrer" className={cls2}>{body}</a> : <Link to={item.link} className={cls2}>{body}</Link>}
    </li>
  );
};
